export const headerRoutes = {
    Home: '/',
    AcomDAO: '/Acom',
}